import { useSelector } from 'react-redux'

import CollapsableCard from 'components/CollapsableCard'
import { selectSubjectIdForCategoryType } from 'ducks/crm/customFieldCategories'
import { selectCustomFieldIdsForCategoryId } from 'ducks/crm/customFields'

import CustomField from './CustomField'
import ContactHeaderFields from './ContactHeaderFields'
import CompanyHeaderFields from './CompanyHeaderFields'

export default function CustomFieldCategory({
  categoryId,
  categoryKey,
  categoryName,
  categoryType,
}) {
  const customFieldIds = useSelector(state =>
    selectCustomFieldIdsForCategoryId(state, { categoryId })
  )
  const subjectId = useSelector(state =>
    selectSubjectIdForCategoryType(state, { type: categoryType })
  )

  if (
    (!customFieldIds || customFieldIds.length === 0) &&
    !['contact_information', 'company_information'].includes(categoryKey)
  ) {
    return null
  }

  return (
    <CollapsableCard persistenceKey={categoryKey} title={categoryName}>
      {categoryKey === 'contact_information' && <ContactHeaderFields />}
      {categoryKey === 'company_information' && <CompanyHeaderFields />}
      {customFieldIds.map(fieldId => {
        return (
          <CustomField
            key={fieldId}
            categoryType={categoryType}
            customFieldId={fieldId}
            subjectId={subjectId}
          />
        )
      })}
    </CollapsableCard>
  )
}
